import ProjectIndex from '@/views/screen/project/index.vue';

// 江苏省标准
const SHARE_JIANGSU = [
  {
    path: 'share/screen-map',
    component: () => import('@/views/screen/project/screen-map'),
  },
  {
    path: 'share/overview',
    component: () => import('@/views/screen/project/project-overview'),
  },
  {
    path: 'share/video-monitor',
    component: () => import('@/views/screen/project/video-monitor'),
  },
  {
    path: 'share/people-management',
    component: () => import('@/views/screen/project/people-management'),
  },
  {
    path: 'share/car-management',
    component: () => import('@/views/screen/project/car-management'),
  },
  {
    path: 'share/green-construction',
    component: () => import('@/views/screen/project/green-construction'),
  },
  {
    path: 'share/safety/tower',
    component: () => import('@/views/screen/project/safety/tower'),
  },
  {
    path: 'share/safety/lift',
    component: () => import('@/views/screen/project/safety/lift'),
  },
  {
    path: 'share/safety/unload',
    component: () => import('@/views/screen/project/safety/unload'),
  },
  {
    path: 'share/safety/pit',
    component: () => import('@/views/screen/project/safety/pit'),
  },
  {
    path: 'share/safety/formwork',
    component: () => import('@/views/screen/project/safety/formwork'),
  },
  {
    path: 'share/safety/protection',
    component: () => import('@/views/screen/project/safety/protection'),
  },
  {
    path: 'share/spot-checking',
    component: () => import('@/views/screen/project/spot-checking'),
  },
  {
    path: 'share/intelligent-weighbridge',
    component: () => import('@/views/screen/project/intelligent-weighbridge'),
  },
  {
    path: 'share/water-electricity',
    component: () => import('@/views/screen/project/water-electricity'),
  },
  {
    path: 'share/ai-recognition',
    component: () => import('@/views/screen/project/ai-recognition'),
  },
  {
    path: 'share/progress-control',
    component: () => import('@/views/screen/project/progress-control'),
  },
  {
    path: 'share/custom-link',
    component: () => import('@/views/screen/project/custom-link'),
  },
];
const SHARE_JIANGSU_PROJECT = [
  {
    path: 'screen-map',
    component: () => import('@/views/screen/project/screen-map'),
  },
  {
    path: 'overview',
    component: () => import('@/views/screen/project/project-overview'),
  },
  {
    path: 'video-monitor',
    component: () => import('@/views/screen/project/video-monitor'),
  },
  {
    path: 'people-management',
    component: () => import('@/views/screen/project/people-management'),
  },
  {
    path: 'car-management',
    component: () => import('@/views/screen/project/car-management'),
  },
  {
    path: 'green-construction',
    component: () => import('@/views/screen/project/green-construction'),
  },
  {
    path: 'safety/tower',
    component: () => import('@/views/screen/project/safety/tower'),
  },
  {
    path: 'safety/lift',
    component: () => import('@/views/screen/project/safety/lift'),
  },
  {
    path: 'safety/unload',
    component: () => import('@/views/screen/project/safety/unload'),
  },
  {
    path: 'safety/pit',
    component: () => import('@/views/screen/project/safety/pit'),
  },
  {
    path: 'safety/formwork',
    component: () => import('@/views/screen/project/safety/formwork'),
  },
  {
    path: 'safety/protection',
    component: () => import('@/views/screen/project/safety/protection'),
  },
  {
    path: 'spot-checking',
    component: () => import('@/views/screen/project/spot-checking'),
  },
  {
    path: 'intelligent-weighbridge',
    component: () => import('@/views/screen/project/intelligent-weighbridge'),
  },
  {
    path: 'water-electricity',
    component: () => import('@/views/screen/project/water-electricity'),
  },
  {
    path: 'ai-recognition',
    component: () => import('@/views/screen/project/ai-recognition'),
  },
  {
    path: 'progress-control',
    component: () => import('@/views/screen/project/progress-control'),
  },
  {
    path: 'custom-link',
    component: () => import('@/views/screen/project/custom-link'),
  },
];

// BI分享大屏路由
const shareScreen = [
  {
    path: '/share',
    component: () => import('@/views/screen/project/share.vue'),
    meta: {
      share: true,
      auth: false,
    },
    children: [
      {
        path: '403',
        component: () => import('@/views/screen/403.vue'),
      },
      ...SHARE_JIANGSU_PROJECT,
    ],
  },
  {
    path: '/share',
    component: () => import('@/views/screen/project/share.vue'),
    meta: {
      share: true,
      auth: false,
    },
  },
  {
    path: '/screen/share',
    component: ProjectIndex,
    meta: {
      share: true,
      auth: false,
    },
  },
  {
    path: '/screen',
    name: 'ScreenShare',
    component: ProjectIndex,
    children: [
      {
        path: 'share/403',
        component: () => import('@/views/screen/403.vue'),
      },
      ...SHARE_JIANGSU.map(item => {
        item.meta = {
          share: true,
          auth: false,
        };
        return item;
      }),
    ],
  },
];

export default shareScreen;
